import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"

// 取得系統設定
export function getConfiguration(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/systems/configuration/",
        method: "get",
        ...config,
    })
}

// 設置系統設定
export function updateConfiguration(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/systems/configuration/`,
        method: "put",
        ...config,
    })
}
